var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAddarti(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 20,
    viewBox: "0 0 19 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.57686 18.387C14.1792 18.387 17.9102 14.656 17.9102 10.0537C17.9102 5.4513 14.1792 1.72034 9.57686 1.72034C4.97449 1.72034 1.24353 5.4513 1.24353 10.0537C1.24353 14.656 4.97449 18.387 9.57686 18.387Z",
    fill: "#071B22"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.57686 6.72034V13.387M6.24353 10.0537H12.9102M17.9102 10.0537C17.9102 14.656 14.1792 18.387 9.57686 18.387C4.97449 18.387 1.24353 14.656 1.24353 10.0537C1.24353 5.4513 4.97449 1.72034 9.57686 1.72034C14.1792 1.72034 17.9102 5.4513 17.9102 10.0537Z",
    stroke: "#EEF2FD",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddarti);
export default __webpack_public_path__ + "static/media/Addarti.2f36038d8181a50d9d2a2189ef81a39a.svg";
export { ForwardRef as ReactComponent };